module.exports = __webpack_public_path__ + "src/assets/games/9/70.jpg";